window.featuredCollectionModule = (() => {
  if (!customElements.get("featured-collection")) {
    customElements.define(
      "featured-collection",
      class FeaturedCollectionComponent extends HTMLElement {
        constructor() {
          super();
          this.initializedNosto = false;
          this.initializedNosto = false
            document.addEventListener("DOMContentLoaded", () => {
              this.init();
            });
        }

        init() {
          window.featuredCollectionSwiperInit = false;
          this.observeTargetDiv();
          this.initializeSwiper();
        }

        observeTargetDiv() {
          const targetDiv = this.querySelector(".js-featured-collection__products");

          if (!targetDiv) return;

          const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
              if (
                mutation.type === "childList" &&
                targetDiv.querySelector(".nosto_element.nosto-dynamic-placement") &&
                !this.initializedNosto
              ) {
                this.initializedNosto = true;
                console.log("INITIALIZED");
                this.initializeSwiper();
              }
            });
          });

          observer.observe(targetDiv, { childList: true, subtree: true });
        }

        initializeSwiper() {
          // Generate unique class names for the Swiper instance and navigation buttons
          let uniqueClass = `js-featured-collection__products-${Math.random().toString(36).substring(2, 10)}`;
          let uniqueNext = `js-featured-collection-next-${Math.random().toString(36).substring(2, 10)}`;
          let uniquePrev = `js-featured-collection-prev-${Math.random().toString(36).substring(2, 10)}`;

          // Apply unique classes
          const productsContainer = this.querySelector(".js-featured-collection__products");
          productsContainer.classList.add(uniqueClass);

          const nextEl = this.querySelector(".js-featured-collection-next");
          const prevEl = this.querySelector(".js-featured-collection-prev");

          if (nextEl) nextEl.classList.add(uniqueNext);
          if (prevEl) prevEl.classList.add(uniquePrev);

          // Initialize Swiper with the unique class names
          this.featuredSwiper = new Swiper(`.${uniqueClass}`, {
            slidesPerView: 1.6,
            spaceBetween: 12,
            freeMode: true,
            breakpoints: {
              1024: {
                spaceBetween: 48,
                slidesPerView: 4,
                slidesPerGroup: 4,
                freeMode: false,
                navigation: {
                  nextEl: `.${uniqueNext}`,
                  prevEl: `.${uniquePrev}`,
                },
              },
            },
          });

          this.handleFadeOuts();
        }

        handleFadeOuts() {
          const leftFadeOuts = Array.from(this.querySelectorAll(".js-generic__fade-out__featured-slider--left"));
          const rightFadeOuts = Array.from(this.querySelectorAll(".js-generic__fade-out__featured-slider--right"));

          leftFadeOuts.forEach((leftFadeOut, i) => {
            this.featuredSwiper.on("progress", (swiper, progress) => {
              this.updateFadeOutVisibility(progress, leftFadeOut, rightFadeOuts[i]);
            });
          });
        }

        updateFadeOutVisibility(progress, leftFadeOut, rightFadeOut) {
          if (progress === 0) {
            leftFadeOut.classList.add("opacity-0");
            rightFadeOut.classList.remove("opacity-0");
          } else if (progress === 1) {
            rightFadeOut.classList.add("opacity-0");
            leftFadeOut.classList.remove("opacity-0");
          } else {
            leftFadeOut.classList.remove("opacity-0");
            rightFadeOut.classList.remove("opacity-0");
          }
        }
      }
    );
  }
})();
